/**
 * Ordre de tri initial pour une colonne marquée `isDefaultSortedColumn`.
 * Sinon toutes les listes restent en ASC.
 */
export function u2000DefaultSortOrderForColumn(col: { defaultSortOrder?: string }): "ASC" | "DESC" {
  return col.defaultSortOrder === "DESC" ? "DESC" : "ASC";
}
